import BlogPostContainer from "./BlogPostContainer";

const Schweden2026 = () => {
    const blogPosts = [
        {
            date: "27.12.2025 - 06.01.2026",
            title: "Schweden",
            content: (
                <>
                </>
            ),
            images: [
                "/images/11_Schweden/1.1.jpeg",
                "/images/11_Schweden/1.2.jpeg",
                "/images/11_Schweden/1.3.jpeg",
            ]
        },
    ];
    return (
        <div className="container my-5">
            <div>
                <h2 className="Blog_Title">Schweden</h2>
            </div>
            {blogPosts.map((post, index) => (
                <BlogPostContainer
                    index={index}
                    title={post.title}
                    date={post.date}
                    content={post.content}
                    images={post.images}
                />
            ))}
        </div>
    );
}
export default Schweden2026;